import React from 'react'
import Dialog from '@material-ui/core/Dialog'

import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import { useMutation } from '@apollo/client'

import { MD_VEHICLETYPE } from 'graphql/mutations'
import styles from '../vehicleType.module.scss'

const DeleteVehicleType = ({ open, setOpen, type, update, loading }) => {
  const [call] = useMutation(MD_VEHICLETYPE)

  const deleteVehicleType = () => {
    loading(true)
    setOpen(false)
    call({ variables: { id: type.id } })
      .then(res => {
        update()
      })
      .catch(err => console.error(err))
  }

  return (
    <div>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <Card>
          <CardContent>
            <Typography color="textSecondary" gutterBottom>
              Confirmation Dialog
            </Typography>
            <Typography variant="h5" component="h2"></Typography>
            <Typography variant="body2" component="p">
              Press the confirmation button to delete {type.vehicleType}
              environment file
            </Typography>
          </CardContent>
          <CardActions>
            <Button
              size="small"
              className={styles.deleteButton}
              onClick={() => deleteVehicleType(type.id)}
            >
              Confirm delete {type.vehicleType}
            </Button>
          </CardActions>
        </Card>
      </Dialog>
    </div>
  )
}

export default DeleteVehicleType
